import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Wallet from '@mui/icons-material/Wallet';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
export const WalletMenuContentEmpty = () => {
    const { t } = useTranslation();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingY: 8,
        }, children: [_jsx(Typography, { sx: {
                    fontSize: 48,
                }, children: _jsx(Wallet, { fontSize: "inherit" }) }), _jsx(Typography, { sx: {
                    fontSize: 18,
                    fontWeight: 700,
                }, children: t('title.availableWalletsNotFound') }), _jsx(Typography, { sx: {
                    fontSize: 14,
                    color: 'text.secondary',
                    textAlign: 'center',
                    mt: 2,
                }, children: t('message.availableWalletsNotFound') })] }));
};
//# sourceMappingURL=WalletMenuContentEmpty.js.map